import {useDebugValue} from 'react';

import {
    useFormActions,
    useFormEvents,
    useFormOptions,
    useFormSettings
} from './';

function useForm(props) {
    const {
        events
    } = useFormEvents(props);

    const {
        options
    } = useFormOptions(props);

    const {
        initialSettings,
        settings,
        changeSettings
    } = useFormSettings(props);

    const actions = useFormActions({
        events,
        options,
        initialSettings,
        settings,
        changeSettings
    });

    const result = {
        actions,
        events,
        options,
        settings
    };

    useDebugValue(result);

    return result;
}

export {useForm};
